import { ValueOf } from '@/helpers/types';

export const UserAccountEvents = {
	LOGIN: 'account_login',
	SIGNUP: 'account_signup',
	DELETE_CLICKED: 'delete_clicked',
	DELETE_CONFIRMED: 'delete_confirmed',
	DELETE_CANCELLED: 'delete_cancelled',
	LOGOUT_CLICKED: 'logout_clicked',
	LOGOUT_CONFIRMED: 'logout_confirmed',
	LOGOUT_CANCELLED: 'logout_cancelled',
	LOGIN_ERROR: 'account_login_error',
	SIGNUP_ERROR: 'account_signup_error',
	RESET_PASSWORD: 'account_reset_password',
	PASSWORD_CHANGED: 'account_password_changed',
	COUNTRY_SELECTED: 'country_selected',
	LANGUAGE_SELECTED: 'language_selected',
	PROVIDER_TOGGLED: 'provider_toggled',
	LOGIN_CLICKED: 'account_sign_in_clicked',
	SIGNUP_CLICKED: 'account_create_clicked',
	CHANGE_EMAIL_CLICKED: 'account_change_email_clicked',
	CHANGE_PASSWORD_CLICKED: 'account_change_password_clicked',
	CHANGE_EMAIL_CONFIRMED: 'account_change_email_confirmed',
	CHANGE_PASSWORD_CONFIRMED: 'account_change_password_confirmed',
	RESEND_VERIFICATION_EMAIL_CLICKED: 'account_resend_verification_email_clicked',
	RESEND_VERIFICATION_EMAIL_CONFIRMED: 'account_resend_verification_email_confirmed',
	RESEND_VERIFICATION_EMAIL_ERROR: 'account_resend_verification_email_error',
	FORGOT_PASSWORD_CLICKED: 'account_forgot_password_clicked',
	COUNTRY_CLICKED: 'country_clicked',
	LANGUAGE_CLICKED: 'language_clicked',
	PROVIDER_CLICKED: 'provider_clicked',
	GO_PRO_CLICKED: 'go_pro_clicked',
	SWITCH_TO_OLD_TITLE_PAGE: 'switch_to_old_title_page',
	SWITCH_TO_NEW_TITLE_PAGE: 'switch_to_new_title_page',
};

export type AuthConsents = {
	acceptedPrivacyPolicy: boolean;
	acceptedEmailAgreement: boolean;
	mode: string;
	location: string;
};

export type SuccessType = 'logged-in' | 'login-failed' | 'sign-up-failed';

export const LoginProvider = {
	GOOGLE: 'google',
	FACEBOOK: 'facebook',
	APPLE: 'apple',
	JUSTWATCH: 'justwatch',
};

export type LoginProvider = ValueOf<typeof LoginProvider>;

export const AccountModes = {
	MAIN: 'MAIN',
	MOBILE_MAIN: 'MOBILE_MAIN',
	SIGN_IN: 'SIGN_IN',
	SIGN_UP: 'SIGN_UP',
	COUNTRY: 'COUNTRY',
	LANGUAGE: 'LANGUAGE',
	PROVIDERS: 'PROVIDERS',
	FORGOT_PASSWORD: 'FORGOT_PASSWORD',
	LOGGING_IN: 'LOGGING_IN',
	SIGNING_UP: 'SIGNING_UP',
	LOGIN_MANAGER: 'LOGIN_MANAGER',
	REGISTRATION_OPTIONS: 'REGISTRATION_OPTIONS',
};

export const AUTH_CONSENTS_KEY = 'AUTH_CONSENTS';
